/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconPrinter(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 25 25"
      color="currentColor"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M6.25 9.375V2.083h12.5v7.292M6.25 18.75H4.167a2.083 2.083 0 0 1-2.083-2.083v-5.209a2.083 2.083 0 0 1 2.083-2.083h16.667a2.083 2.083 0 0 1 2.083 2.083v5.209a2.083 2.083 0 0 1-2.084 2.083H18.75"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M18.75 14.583H6.25v8.333h12.5z"
      />
    </svg>
  );
}
